import React from 'react';
import { Link } from 'react-router-dom';
export function TherapistProfiles() {
  return <section id="therapeutinnen" className="w-full py-20 px-6 md:px-12 bg-gray-50" data-id="element-239">
      <div className="max-w-5xl mx-auto text-center mb-16" data-id="element-240">
        <h2 className="text-3xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-241">
          Wohin möchten Sie?
        </h2>
      </div>
      <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto" data-id="element-242">
        <div className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 flex flex-col" data-id="element-243">
          <div className="h-80 overflow-hidden" data-id="element-244">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qPSh5jJHMvyuJqwzE92tue/Angelika_Sturny-v3.jpg" alt="Dr. Angelika Sturny" className="w-full h-full object-cover" data-id="element-245" />
          </div>
          <div className="p-8 flex-grow bg-white" data-id="element-246">
            <h3 className="text-2xl font-medium text-gray-700 mb-2" data-id="element-247">
              Dr. Dipl.-Psych. Angelika Sturny
            </h3>
            <p className="text-gray-500 mb-1" data-id="element-248">Diplom-Psychologin</p>
            <p className="text-gray-500 mb-4" data-id="element-249">München</p>
            <div className="text-gray-600 mb-6" data-id="element-250">
              <p className="mb-4" data-id="element-251">Schwerpunkte:</p>
              <ul className="list-disc pl-5 space-y-1 mb-6" data-id="element-252">
                <li data-id="element-253">Einzelberatung und Psychotherapie</li>
                <li data-id="element-254">Systemische Familientherapie</li>
                <li data-id="element-255">Systemische Paartherapie</li>
                <li data-id="element-256">Beratung und Therapie für Kinder und Jugendliche</li>
              </ul>
              <div className="border-t border-gray-200 pt-4" data-id="element-257">
                <p className="text-gray-600 mb-2" data-id="element-258">85540 Haar bei München</p>
                <p className="text-gray-600" data-id="element-259">
                  E-Mail:{' '}
                  <a href="mailto:praxis@angelikasturny.com" className="hover:text-[#c2cde0] transition-colors" data-id="element-260">
                    praxis@angelikasturny.com
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className="p-8 pt-0" data-id="element-261">
            <Link to="/angelika_sturny" className="block w-full" data-id="element-262">
              <button className="w-full py-3 px-6 text-gray-700 rounded-md hover:font-semibold transition-colors" style={{
              backgroundColor: '#cda8be'
            }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#b88fa8'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#cda8be'} data-id="element-263">
                Zur Praxis in München
              </button>
            </Link>
          </div>
        </div>
        <div className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 flex flex-col" data-id="element-264">
          <div className="h-80 overflow-hidden" data-id="element-265">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6JnSMCV1D4RDNfks7VxLDi/Eva_Schifferer-v3.jpg" alt="Eva Sophie Schifferer" className="w-full h-full object-cover" data-id="element-266" />
          </div>
          <div className="p-8 flex-grow bg-white" data-id="element-267">
            <h3 className="text-2xl font-medium text-gray-700 mb-2" data-id="element-268">
              Dipl.-Psych. Eva Sophie Schifferer
            </h3>
            <p className="text-gray-500 mb-1" data-id="element-269">Diplom-Psychologin</p>
            <p className="text-gray-500 mb-4" data-id="element-270">Frankfurt</p>
            <div className="text-gray-600 mb-6" data-id="element-271">
              <p className="mb-4" data-id="element-272">Schwerpunkte:</p>
              <ul className="list-disc pl-5 space-y-1 mb-6" data-id="element-273">
                <li data-id="element-274">Paarberatung und Paartherapie</li>
                <li data-id="element-275">Einzeltherapie</li>
                <li data-id="element-276">Coaching</li>
                <li data-id="element-277">Mentale Gesundheit</li>
              </ul>
              <div className="border-t border-gray-200 pt-4" data-id="element-278">
                <p className="text-gray-600 mb-1" data-id="element-279">Rohrbachstraße 35</p>
                <p className="text-gray-600 mb-2" data-id="element-280">60389 Frankfurt</p>
                <p className="text-gray-600" data-id="element-281">
                  E-Mail:{' '}
                  <a href="mailto:praxis@evaschifferer.com" className="hover:text-[#c2cde0] transition-colors" data-id="element-282">
                    praxis@evaschifferer.com
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className="p-8 pt-0" data-id="element-283">
            <Link to="/eva_schifferer" className="block w-full" data-id="element-284">
              <button className="w-full py-3 px-6 bg-blue-100 text-gray-700 rounded-md hover:bg-[#c2cde0] hover:font-semibold transition-colors" data-id="element-285">
                Zur Praxis in Frankfurt
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}